import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { ReactiveFormsModule } from "@angular/forms";
import { SvcSlideToggleComponent } from './svc-slide-toggle.component';

@NgModule({
  declarations: [
    SvcSlideToggleComponent
  ],
  imports: [
    CommonModule,
    MatSlideToggleModule,
    ReactiveFormsModule
  ],
  exports: [
    SvcSlideToggleComponent
  ]
})
export class SvcSlideToggleModule { }
